import React from 'react';
import { LegalLayout } from '../components/LegalLayout';
export function Terms() {
  return <LegalLayout title="Términos de Servicio" updated="17 de mayo, 2026" data-id="element-269">
      <section className="legal-section" data-id="element-270">
        <h2 data-id="element-271">Naturaleza del producto</h2>
        <p data-id="element-272">
          A.R.M.O.N.Y. es un recurso educativo digital. No constituye asesoría
          médica, diagnóstico ni tratamiento. Consulta siempre con profesionales
          médicos certificados antes de tomar decisiones sobre tu cuerpo. Los
          resultados individuales varían según cada caso.
        </p>
      </section>

      <section className="legal-section" data-id="element-273">
        <h2 data-id="element-274">Licencia de uso</h2>
        <p data-id="element-275">
          Al comprar el bundle obtienes una licencia personal, no exclusiva e
          intransferible para acceder al material. No está permitido revender,
          redistribuir, copiar parcial o totalmente, ni publicar el contenido en
          plataformas públicas. Todos los derechos de autor permanecen con
          Dermaclinic Method.
        </p>
      </section>

      <section className="legal-section" data-id="element-276">
        <h2 data-id="element-277">Pago y entrega</h2>
        <p data-id="element-278">
          El pago se procesa a través de Shopify. La entrega es digital e
          inmediata por correo electrónico tras la confirmación del pago. Si no
          recibes los archivos en un plazo de 15 minutos, revisa tu carpeta de
          spam o escríbenos a{' '}
          <a href="mailto:sales@dermaclinicenter.com" data-id="element-279">
            sales@dermaclinicenter.com
          </a>
          .
        </p>
      </section>

      <section className="legal-section" data-id="element-280">
        <h2 data-id="element-281">Reembolso</h2>
        <p data-id="element-282">
          Garantía de 14 días según los términos completos en nuestra{' '}
          <a href="/refund" data-id="element-283">política de reembolso</a>.
        </p>
      </section>

      <section className="legal-section" data-id="element-284">
        <h2 data-id="element-285">Limitación de responsabilidad</h2>
        <p data-id="element-286">
          Dermaclinic y sus afiliados no son responsables por decisiones
          médicas, quirúrgicas o financieras tomadas con base en el material. El
          bundle es un recurso de preparación; no sustituye consulta profesional
          con un cirujano certificado. La responsabilidad máxima por cualquier
          reclamación se limita al precio pagado por el producto.
        </p>
      </section>

      <section className="legal-section" data-id="element-287">
        <h2 data-id="element-288">Modificaciones</h2>
        <p data-id="element-289">
          Podemos actualizar estos términos en cualquier momento. La versión
          vigente es la publicada en esta página. Los cambios sustanciales se
          notificarán por correo a quienes hayan comprado el bundle.
        </p>
      </section>

      <section className="legal-section" data-id="element-290">
        <h2 data-id="element-291">Jurisdicción</h2>
        <p data-id="element-292">
          Estos términos se rigen por las leyes del estado de Florida, Estados
          Unidos. Cualquier disputa se resolverá en los tribunales competentes
          de Miami, FL.{' '}
          <em data-id="element-293">(Sujeto a revisión por asesor legal antes de publicación.)</em>
        </p>
      </section>

      <section className="legal-section" data-id="element-294">
        <h2 data-id="element-295">Contacto</h2>
        <p data-id="element-296">
          Dermaclinic Method ·{' '}
          <a href="mailto:sales@dermaclinicenter.com" data-id="element-297">
            sales@dermaclinicenter.com
          </a>
        </p>
      </section>
    </LegalLayout>;
}